<template>
  <div>
    <slot />
  </div>
</template>

<script>
import { defineComponent, inject, onMounted } from '@vue/composition-api'

import { CompanyService } from '@services'

export default defineComponent({
  name: 'CompanyRLSGroupWrapper',
  setup() {
    const { companyId, setCompany } = inject('company-rls-group')

    const fetchCompany = async () => {
      try {
        const { data } = await CompanyService.read(companyId.value)
        const { data: results } = data || {}

        setCompany(results.data)
      } catch (_) {
        setCompany({})
      }
    }

    onMounted(fetchCompany)

    return {}
  }
})
</script>
